export const rowColNomeOrgaoVinculado = {
    xs: { span: 24, offset: 0 }, //<576
    sm: { span: 24, offset: 0 }, //>576
    md: { span: 24, offset: 0 }, // >768
    lg: { span: 10, offset: 0 }, // > 992
    xl: { span: 10, offset: 0 }, // > 1200
    xxl: { span: 10, offset: 0 }, // > 1600
};

export const rowColTableOrgaosVinculados = {
    xs: { span: 24, offset: 0 }, //<576
    sm: { span: 24, offset: 0 }, //>576
    md: { span: 24, offset: 0 }, // >768
    lg: { span: 14, offset: 0 }, // > 992
    xl: { span: 14, offset: 0 }, // > 1200
    xxl: { span: 14, offset: 0 }, // > 1600
};

export const inputNomeOrgaoVinculado = {
    xs: { span: 24, offset: 0 }, //<576
    sm: { span: 24, offset: 0 }, //>576
    md: { span: 24, offset: 0 }, // >768
    lg: { span: 24, offset: 0 }, // > 992
    xl: { span: 24, offset: 0 }, // > 1200
    xxl: { span: 24, offset: 0 }, // > 1600
};
